import { editFigureDataEffect } from "../figure-modal.js";
import { GraphicsWidget } from "./graphics.js";

export class EditableGraphicsWidget extends GraphicsWidget {
    setEditDispatcher(button, view) {
        button.classList.toggle("hidden", !this.figureData);
        if (!this.figureData) {
            button.onmousedown = null;
            return;
        }

        button.onmousedown = (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            view.dispatch({
                effects: editFigureDataEffect.of(this.figureData),
            });
            window.dispatchEvent(new CustomEvent("figure-modal:open-modal"));
            return false;
        };
    }

    updateDOM(element, view) {
        const updated = super.updateDOM(element, view);
        if (!updated) {
            return false;
        }

        const button = element.querySelector(".ol-cm-graphics-edit-button");
        if (button) {
            this.setEditDispatcher(button, view);
        }
        return true;
    }

    createEditButton(view) {
        const button = document.createElement("button");
        const phrase = typeof view?.state?.phrase === "function" ? view.state.phrase("edit_figure") : "";
        button.setAttribute("aria-label", phrase || "Edit figure");
        button.classList.add("btn", "btn-secondary", "ol-cm-graphics-edit-button", "icon-button", "d-inline-grid");
        const buttonContent = button.appendChild(document.createElement("span"));
        buttonContent.className = "button-content";
        buttonContent.textContent = "edit";
        this.setEditDispatcher(button, view);
        return button;
    }

    renderGraphic(element, view) {
        super.renderGraphic(element, view);
        if (this.figureData) {
            element.prepend(this.createEditButton(view));
        }
    }
}
